"use client"
import { BlockchainAPI } from "@/api/blockchainApi";
import { GetRecordDataResponse } from "@/types/api.types";
import { faArrowUpRightFromSquare, faSearch } from "@fortawesome/free-solid-svg-icons";
import { Alert, Button, InputField } from "@itlogix/itlogix-ui";
import { Box, Card, Chip, CircularProgress, Link, Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";
import { Fragment, useEffect, useState } from "react";


export default function InfoCard() {
    const searchParams = useSearchParams();
    const t = useTranslations('Dashboard');

    const [transictionIdToSearch, setTransictionIdToSearch] = useState("");
    const [isIdMissing, setIsIdMissing] = useState(false);
    const [dataObj, setDataObj] = useState<GetRecordDataResponse | null>(null)
    const [areDataLoaded, setAreDataLoaded] = useState(false);
    const [errorObj, setErrorObj] = useState({
        showError: false,
        errorMsg: "Errore durante il recupero delle informazioni"
    })



    useEffect(() => {
        const transictionId = searchParams.get("transactionId") ?? null;
        if (transictionId) {

            getRecordData(transictionId);
        }
        else {
            setErrorObj({
                showError: true,
                errorMsg: "ID non valido"
            })
            setIsIdMissing(true);
            setAreDataLoaded(true);
        }
    }, [searchParams]);

    function returnStatoMsg(stato: number): any {
        if (stato === 1) {
            return {
                msg: "Record verificato",
                severity: "success"
            }
        } else if (stato === 2) {
            return {
                msg: "Record in coda di trascrizione su BC",
                severity: "primary"
            }
        } else if (stato === 3) {
            return {
                msg: "Record non verificato",
                severity: "error"
            }
        }
    }

    function submitForm(event: React.FormEvent) {
        event.preventDefault();
        if (transictionIdToSearch !== "")
            getRecordData(transictionIdToSearch);
    }

    async function getRecordData(transictionID: string) {
        const url = new URL(window.location.href);
        url.searchParams.set('transactionId', transictionID);
        window.history.replaceState(null, '', url.toString());

        setIsIdMissing(false);
        setAreDataLoaded(false)
        const dataObj = {
            internalTxID: transictionID
        }
        const response = await BlockchainAPI.getRecordData(dataObj);
        if (response && response.data && response.success) {
            setDataObj(response.data)
            setErrorObj({
                ...errorObj,
                showError: false
            })
        } else {
            setErrorObj({
                showError: true,
                errorMsg: response.message ?? "Errore durante il recupero delle informazioni"
            })
        }
        setAreDataLoaded(true);
    }
    return (
        <Card className="card">
            {areDataLoaded ? (
                <Fragment>
                    {!errorObj.showError ? (
                        <Box className="tw:flex tw:flex-col tw:gap-3">
                            <Box className="tw:flex tw:items-center tw:gap-3">
                                <Typography variant="h1" className="tw:text-4xl">{dataObj?.Blockchain}</Typography>
                                <Chip color={returnStatoMsg(dataObj?.Stato ?? 3)?.severity} label={returnStatoMsg(dataObj?.Stato ?? 3)?.msg} />

                            </Box>
                            <Box className="tw:flex tw:flex-col tw:justify-start tw:gap-3">
                                <Typography sx={{ color: 'primary.main', fontWeight: 'bold' }}>Internal transaction ID:</Typography>
                                <Typography className="tw:break-all">{dataObj?.InternalTransactionID}</Typography>
                                <Typography sx={{ color: 'primary.main', fontWeight: 'bold' }}>Polygon transaction ID:</Typography>
                                <Typography className="tw:break-all"> {dataObj?.PolygonTransactionID}</Typography>
                                <Typography sx={{ color: 'primary.main', fontWeight: 'bold' }}>Blockchain Hash:</Typography>
                                <Typography className="tw:break-all"> {dataObj?.BlockchainHash}</Typography>
                                <Typography sx={{ color: 'primary.main', fontWeight: 'bold' }}>Offchain Hash:</Typography>
                                <Typography className="tw:break-all">{dataObj?.OffchainHash}</Typography>
                                {dataObj?.Stato === 1 && (
                                    <Box sx={{ mt: 3 }}>
                                        <Link target="_blank" href={dataObj?.LinkBlockExplorer}>
                                            <Button isFullWidth variant="outlined" severity="primary" icon={faArrowUpRightFromSquare} label="Link block explorer" />
                                        </Link>
                                    </Box>
                                )}
                            </Box>
                        </Box>) : (
                        <Box className="tw:flex tw:flex-col tw:gap-3 tw:w-full">
                            {!isIdMissing && (
                                <Alert severity="error">{errorObj.errorMsg}</Alert>
                            )}
                            <form onSubmit={submitForm} className="tw:w-full">
                                <Box className="tw:flex tw:gap-3 tw:w-full">
                                    <InputField inputChanged={(value) => { setTransictionIdToSearch(value) }} isFullWidth placeholder="Inserisci ID transazione" />
                                    <Button type="submit" isDisabled={transictionIdToSearch === ""} variant="contained" severity="primary" icon={faSearch} label="Cerca" />
                                </Box>
                            </form>

                        </Box>
                    )}
                </Fragment>
            ) : (
                <Box className="tw:flex tw:items-center tw:flex-col tw:gap-3">
                    <CircularProgress />
                    <Typography>Caricamento dati...</Typography>
                </Box>
            )
            }

        </Card >

    );
}